<template>
  <element>
    <el-row>
      <el-col>
        <panel label="基本信息">
          <form-build
            :form-data="customerData"
            :form-columns="customerColumns"
            class="formTable"
          />
        </panel>
        <panel label="证件图片" class="zhengjianxinxi">
          <photo-browser v-model="customerData.i__bizrepICURL1" label="本人身份证正面"/>
          <photo-browser v-model="customerData.i__bizrepICURL2" label="本人身份证反面"/>
          <photo-browser v-model="customerData.ix__extSpouseIDFront" label="配偶身份证正面"/>
          <photo-browser v-model="customerData.ix__extSpouseIDBack" label="配偶身份证反面"/>
          <photo-browser v-model="customerData.ix__extMarriageCert" label="结婚证明"/>

          <photo-browser v-model="customerData.ix__extHouseholdRegBook1" label="本人户口本主页"/>
          <photo-browser v-model="customerData.ix__extHouseholdRegBook2" label="本人户口本"/>
          <photo-browser v-model="customerData.ix__extHouseholdRegBook3" label="配偶户口本"/>
          <photo-browser v-model="customerData.ix__extResidencePermit" label="借款人居住证"/>
          <photo-browser v-model="customerData.ix__extSpouseResidencePermit" label="借款人配偶居住证"/>
        </panel>
        <panel label="资产证明" class="zhengjianxinxi">
          <photo-browser v-model="customerData.ix__extPropertyCert" label="房产证"/>
          <photo-browser v-model="customerData.ix__extPropertyPhoto" label="房屋照片"/>
        </panel>
        <panel label="征信证明" class="zhengjianxinxi">
          <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerData.ix__extBizAnalysis" :editable="false" ></file-upload>借款人运营情况分析报告</div>
          <div class="zhenjianyyzz zhenjianyyzz2"> <file-upload  v-model="customerData.ix__extBankStatement" :editable="false" ></file-upload>借款人银行流水</div>
          <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerData.ix__extGovStatement" :editable="false" ></file-upload>最近3个月社保或公积金缴纳明细</div>
          <photo-browser v-model="customerData.ix__extCreditReportAuth" label="代拉征信授权书"/>
          <div class="zhenjianyyzz zhenjianyyzz2"><file-upload  v-model="customerData.ix__extCreditReport" :editable="false" ></file-upload>征信报告</div>


        </panel>
        <panel label="贷款相关图片" class="zhengjianxinxi">
          <photo-browser v-model="customerData.ix__extBankCard" label="借款人银行卡"/>
          <photo-browser v-model="customerData.ix__extAppearancePhoto" label="夫妻双方现场照"/>
          <photo-browser v-model="customerData.ix__extSigningPhoto1" label="夫妻双方签合同照片" v-if="isShowPic1"/>
         <!-- <photo-browser v-model="customerData.ix__extLoanForm1" label="借款人申报表"/>
          <photo-browser v-model="customerData.ix__extLoanForm2" label="借款人报价单"/>-->
        </panel>

        <panel label="授信合同" class="zhengjianxinxi" v-if="customerData.ix__extLoanForm3!=null">
          <div class="zhenjianyyzz zhenjianyyzz2"><a :href="'../files/'+customerData.ix__extLoanForm3+'/contract.pdf'" download=""><img src="../../assets/images/pdf.jpg" ></a></div>
        </panel>
          <panel label="授信合同" class="zhengjianxinxi" v-if="customerData.ix__extLoanForm3==null">
          <div class="zhenjianyyzz zhenjianyyzz2"><img src="../../assets/images/nopdf.jpg"></div>
        </panel>
      </el-col>
      <el-col>
      </el-col>
    </el-row>
  </element>
</template>

<script>
  import sexOptions from '../../utils/sexOptions'
  import {getImageUrl} from '../../filters/CommonActions'
  import Status2CN from "../../filters/Status2CN";
  import moment from 'moment'
  import Constant from "../../utils/constant";
  export default {
    name: "CustomerDetailComponent",
    data() {
      return {
        customerColumns: [
          {
            label: '客户编号',
            field: 'c__customerCode',
            formatter: function (r,v) {
              return  v ? v : '待生成'
            }
          },
          {
            label: '身份证号码',
            field: 'i__socialIdentityCode',
          },
          {
            label: '客户姓名',
            field: 'i__contactPerson'
          },
          {
            label: '性别',
            field: 'ix__extGender',
            formatter: function(r,v) {
              if(v!=null){
                return Status2CN('Sex_'+v)
              }else{
                return ''
              }

            },

          },


          {
            label: '手机号',
            field: 'i__contactTelNo'
          },
          {
            label: '业务员',
            field: 'ix__extSalesPerson',
          },
          {
            label: '常住地址',
            field: 'i__address',
            formatter: function(r,v) {
              return (r.i__province||'') + (r.i__city||'') + v
            },
            span:24,
          },
          {
            label: '婚姻状况',
            field: 'ix__extMaritalStatus',
          },
          {
            label: '配偶姓名',
            field: 'ix__extSpouseName'
          },
          {
            label: '配偶手机',
            field: 'ix__extSpouseContactTelNo'
          },
          {
            label: '配偶身份证号',
            field: 'ix__extSpouseIC'
          },
          {
            label: '配偶工作单位',
            field: 'ix__extSpouseEmployedBy'
          },
          {
            label: '配偶工作地址',
            field: 'ix__extSpouseEmployAddress',
            span:24,
          },
          {
            label: '获客渠道',
            field: 'ix__channel',
          },
          {
            label: '个人征信状况',
            field: 'ix__extCreditDesc',
          },
          {
            label: '服务年限',
            field: 'ix__extServicingPeriod',
            formatter: function(r,v) {
              return  v+'（'+r.ix__channel+'）'
            },
          },
          {
            label:'建议授信额度',
            field:'ix__extLineOfCredit'
          }
        ],
      }
    },
    props: {
      value: {
        type: Object
      },
      isShowPic1: {
        Boolean,
        default: false
      }
    },
    computed: {
      customerData: {
        get: function () {
          return this.value
        },
        set: function (newVal) {
          this.$emit('input', newVal)
        }
      }
    },
    filters: {
      getImageUrl,
      sex2CN: function (sex) {
        let sexItem = sexOptions.filter(item=>item.value==sex).shift()||[]
        return sexItem.label||''
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/components/CustomerDetailComponent.vue